import i18n from "i18next";
import React from "react";
import { call, put, select, all, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./networkPoliciesGetActions";
import { arrayToMap, addObjectIdField, links, isGranularFlow } from "@p81-common/shell-core-js";
import { showNotif } from "@p81-common/ui";
import {
  SOCKET_EVENT_NETFILTER_UPDATE_SUCCESS,
  SOCKET_EVENT_ENABLE_FIREWALL_LOGS_SUCCESS
} from "store/api/organization/networksBeaconsGet/networksBeaconsGetActions";

export function flatValues(array) {
  return array.reduce((acc, obj) => {
    if ("user_group".includes(obj.type) && obj.valueType === "single") {
      let existingItem = acc.find((item) => item.type === obj.type);
      if (existingItem) {
        existingItem.value.push(...obj.value);
      } else {
        obj.valueType = "list";
        acc.push(obj);
      }
    } else {
      acc.push(obj);
    }
    return acc;
  }, []);
}

function* networkPoliciesGet() {
  try {
    // Determine URL based on granular flow
    
    const url =  "network-policies";
    
    let { data } = yield call(
      requestWithSubTenantIfNeeded,
      "get",
      url
    );
 
    let { networkPolicies, relationships } = data;

    for (let policy of networkPolicies) {
      for (let rule of policy.networkPolicyRules) {
        rule.sources = flatValues(rule.sources);
        rule.destinations = flatValues(rule.destinations);
      }
    }

    relationships.users.forEach((user) => {
      if (typeof user.icon === "string") {
        user.icon = {
          url: `${links.imagesBaseUrl}/icons/${user.icon}`,
        };
      }
    });

    relationships.groups = arrayToMap(
      "_id",
      relationships.groups,
      addObjectIdField
    );
    relationships.users = arrayToMap(
      "_id",
      relationships.users,
      addObjectIdField
    );
    // place policies with rules on top and preserve original order
    networkPolicies.sort((a, b) => {
      if (
        a.networkPolicyRules.length > 0 &&
        b.networkPolicyRules.length === 0
      ) {
        return -1;
      }
      if (
        a.networkPolicyRules.length === 0 &&
        b.networkPolicyRules.length > 0
      ) {
        return 1;
      }
      return 0;
    });

    yield put(actions.requestSuccess(data));
  } catch (error) {
    yield put(actions.requestFailure(error));
  }
}

function* showNotification(action) {
  let network = yield select(
    (s) => {
      const networkBeaconData = action.data.networkBeacon.data;
      const actionNetworkId = networkBeaconData.networkPolicy?.network || networkBeaconData.network?.id;
      return s.networkPoliciesGet.data.networkPolicies.find(
        (p) => p.id === actionNetworkId
      )?.networkName ||
        s.networksGet.data.networks.find(
          (n) => n.id === actionNetworkId
        )?.name
    }
  );
  if (network) {
    yield call([i18n, i18n.loadNamespaces], "policies");
    showNotif(
      <span
        dangerouslySetInnerHTML={{
          __html: i18n.t("policies:npr.table.messages.applied", { network }),
        }}
      />,
      {
        ms: 5000,
        alertProps: {
          severity: "success",
          variant: "filled",
        },
      }
    );
  }
}

function* saga() {
  yield all([
    takeEvery(actions.NETWORK_POLICIES_GET_REQUEST, networkPoliciesGet),
    takeEvery(SOCKET_EVENT_NETFILTER_UPDATE_SUCCESS, showNotification),
    takeEvery(SOCKET_EVENT_ENABLE_FIREWALL_LOGS_SUCCESS, showNotification),
  ]);
}

export default saga;
